module.exports = __webpack_public_path__ + "media/images/flags/sr-690504905775fc1b1480f659e631a028.svg";